/* ============================================================
 * TF · Motion runtime — reveals + luz-cursor + tilt (handoff §9).
 * Reproduce el motion del prototipo con: IntersectionObserver para reveals
 * (máscara clip-path abajo→arriba + stagger), luz de 340px que sigue el cursor
 * en cards, y tilt ≤2.6°. Un solo rAF (no perpetuo). Solo transform/opacity/
 * filter/clip-path. Respeta prefers-reduced-motion (no toca nada → CSS deja todo
 * visible) y trae un failsafe de 700ms para que el contenido nunca quede oculto.
 * Se carga una vez desde tf-header. Parallax: soportado vía [data-tf-parallax]
 * (targets se habilitan cuando el elemento está sobredimensionado, sin gaps).
 * ============================================================ */
(function () {
  "use strict";
  if (window.__tfMotion) return; window.__tfMotion = true;

  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var fine = matchMedia("(pointer: fine)").matches;
  var root = document.documentElement;

  function ready(fn) { document.readyState !== "loading" ? fn() : document.addEventListener("DOMContentLoaded", fn); }

  ready(function () {
    if (reduce) return; // sin motion JS: el CSS deja todo el contenido visible
    root.classList.add("tf-motion");

    /* ── Ritmo de entrada por colección (motion_preset · §9) ── */
    var rhythmEl = document.querySelector("[data-tf-rhythm]");
    var preset = (rhythmEl && rhythmEl.getAttribute("data-tf-rhythm")) || "balanced";
    var RHYTHM = { crisp: [620, 70], balanced: [820, 95], heavy: [980, 130], archival: [1000, 150] };
    var R = RHYTHM[preset] || RHYTHM.balanced;
    var revealDur = R[0], staggerStep = R[1];
    root.style.setProperty("--tf-reveal-dur", revealDur + "ms");

    /* ── Scroll reveals (máscara + stagger por sección) ── */
    var revealSel = ".tf-heading--display,.tf-heading--section,.tf-eyebrow,.tf-look-card," +
      ".tf-editorial-card,.tf-tile,.tf-stat,.tf-swproof__stat,.tf-swproof__media," +
      ".tf-colhero__foot,.tf-concept__line,.tf-concept__body,.tf-credits__row," +
      ".tf-next__link,.tf-rail__cell,.tf-news__inner,.tf-qcta__inner";
    var targets = [].slice.call(document.querySelectorAll(revealSel));
    var secCount = new WeakMap();
    targets.forEach(function (el) {
      el.classList.add("tf-reveal");
      var sec = el.closest("section") || document.body;
      var i = secCount.get(sec) || 0;
      secCount.set(sec, i + 1);
      el.style.transitionDelay = Math.min(i, 6) * staggerStep + "ms"; // stagger por sección (preset)
    });
    var reveal = function (el) { el.classList.add("is-in"); };
    var failsafe = setTimeout(function () { targets.forEach(reveal); }, 700);
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (e) { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
      targets.forEach(function (el) { io.observe(el); });
    } else {
      targets.forEach(reveal);
    }
    void failsafe;

    if (!fine) { root.classList.add("tf-touch"); return; } // touch: sin luz/tilt/parallax

    /* ── Luz que sigue el cursor + tilt en cards ── */
    var cards = [].slice.call(document.querySelectorAll(".tf-tile,.tf-look-card,.tf-editorial-card"));
    cards.forEach(function (card) {
      card.addEventListener("pointermove", function (e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
        card.style.setProperty("--gx", (px * 100).toFixed(1) + "%");
        card.style.setProperty("--gy", (py * 100).toFixed(1) + "%");
        card.style.setProperty("--tf-tiltx", ((py - 0.5) * -2.6).toFixed(2) + "deg");
        card.style.setProperty("--tf-tilty", ((px - 0.5) * 2.6).toFixed(2) + "deg");
        card.classList.add("tf-lit");
      });
      card.addEventListener("pointerleave", function () {
        card.classList.remove("tf-lit");
        card.style.setProperty("--tf-tiltx", "0deg");
        card.style.setProperty("--tf-tilty", "0deg");
      });
    });

    /* ── Parallax scroll-driven (rAF throttled, no perpetuo) — [data-tf-parallax]
       en capas sobredimensionadas (inset:-10%) para que nunca se vean bordes. ── */
    var pars = [].slice.call(document.querySelectorAll("[data-tf-parallax]"));
    if (pars.length) {
      var praf = null;
      var ptick = function () {
        praf = null;
        var vh = window.innerHeight;
        for (var i = 0; i < pars.length; i++) {
          var el = pars[i], sp = parseFloat(el.getAttribute("data-tf-parallax")) || 0.06;
          var r = el.getBoundingClientRect();
          if (r.bottom < -200 || r.top > vh + 200) continue;     // fuera de vista: no calcular
          var off = ((r.top + r.height / 2) - vh / 2) * sp * -1;
          el.style.transform = "translate3d(0," + off.toFixed(1) + "px,0)";
        }
      };
      var pschedule = function () { if (!praf) praf = requestAnimationFrame(ptick); };
      window.addEventListener("scroll", pschedule, { passive: true });
      window.addEventListener("resize", pschedule, { passive: true });
      ptick(); // posición inicial
    }
  });
})();
